export default "__VITE_ASSET__CSVC7pPB__"